import { render, staticRenderFns } from "./UiPopupMenu.vue?vue&type=template&id=1b0a1a74"
import script from "./UiPopupMenu.vue?vue&type=script&lang=ts"
export * from "./UiPopupMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports